export default "__VITE_ASSET__DxGcBYql__"